import { Grid } from "@mui/material";
import React from "react";
import "../../assets/css/competition.scss";
import date from "../../assets/images/date.svg";
import timer from "../../assets/images/timer.svg";
import Title from "./title";
import first from "../../assets/images/1st.svg";
import second from "../../assets/images/2nd.svg";
import third from "../../assets/images/3rd.svg";
import Popover from "@mui/material/Popover";
import edit from "../../assets/images/Edit-alt.svg";
import Delete from "../../assets/images/delete.svg";
import CountDown from "../../utilities/Countdown";

const CompetitionBox = ({
  data,
  button,
  Edit,
  status,
  handleDelete,
  handleFormEdit,
  ButtonShow,
  handleLeaderboardClick,
  handleclick,
  isCommunity = false,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <Grid lg={3.9} xl={3} className="Container-p-20 CompetitionBoxContainer">
      <div className="d-flex justify-content-between align-items-center">
        <div className="CompName">
          <div className="CBHead">{/*props.CompDate*/}</div>
          <div className="CBHead mbb-10">{data && data.competition_name}</div>
        </div>
        <div>{/*StatFormatter(props.CompStat)*/}</div>
        {Edit === "true" && (
          <div>
            <div
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                color: "white",
                cursor: "pointer",
              }}
              aria-describedby={id}
              variant="contained"
              onClick={handleClick}
            >
              ...
            </div>
            <Popover
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              id={id}
              className="CompPopover"
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
            >
              <div className="PopoverComp Container-p-20">
                <div
                  className="d-flex gapp-10 mbb-20"
                  onClick={(e) => handleFormEdit(data.id, status)}
                >
                  <img src={edit} alt="" />
                  <Title four>Edit</Title>
                </div>
                <div
                  className="d-flex gapp-10 "
                  onClick={(e) => handleDelete(data && data.id)}
                >
                  <img src={Delete} alt="" />
                  <Title four>Delete</Title>
                </div>
              </div>
            </Popover>
          </div>
        )}
      </div>
      <div className="rules_wrapper">
        <div className="Date d-flex gapp-10 mbb-20">
          <img src={date} alt="" />
          <div className="date">
            {data &&
              `${new Date(data.Start_date).toDateString()} - ${new Date(
                data.End_Date
              ).toDateString()}`}
          </div>
        </div>
        <div className="Timer d-flex gapp-10 mbb-20">
          <img src={timer} alt="" />
          <div className="date" style={{ color: "#fff" }}>
            {/* <Timer startDate={startDate} /> */}
            {/*props.CountTime*/}
            <CountDown CountDate={data && data.End_Date} />
          </div>
        </div>
        <div className="d-flex gapp-5 mbb-20">
          <Title three>Challenge Accounts : </Title>
          <Title four> {(data && data.contestants) || 0} Contestants</Title>
        </div>
        <div>
          <div className="mbb-30 winnerTitle">
            <Title className="winnerTitle" three>
              Top 3 winner gets
            </Title>
          </div>
          <div className="mbb-10">
            <div className="d-flex gapp-10 mbb-5">
              <img src={first} alt="" />
              <div className="d-flex">
                <Title four>1st Prize - </Title>
                <Title four>{data && data.First_prize}</Title>
              </div>
            </div>
            <div className="d-flex gapp-10 mbb-5">
              <img src={second} alt="" />
              <div className="d-flex">
                <Title four>2nd Prize - </Title>
                <Title four>{data && data.second_prize}</Title>
              </div>
            </div>
            <div className="d-flex gapp-10 mbb-5">
              <img src={third} alt="" />
              <div className="d-flex">
                <Title four>3rd Prize - </Title>
                <Title four>{data && data.Third_prize}</Title>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="compbutton">
        {ButtonShow && (
          <button
            type="button"
            // disabled={props.ended || props.Participated}
            className="d-flex align-items-center justify-content-center gapp-10"
            onClick={handleclick}
          >
            <Title four>{button}</Title>
            <span>
              <svg
                width="14"
                height="10"
                viewBox="0 0 14 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.97 1.53082C7.83752 1.38865 7.7654 1.2006 7.76882 1.0063C7.77225 0.812 7.85097 0.626614 7.98838 0.489201C8.12579 0.351788 8.31118 0.273076 8.50548 0.269648C8.69978 0.26622 8.88783 0.338343 9.03 0.470823L13.03 4.47082C13.1705 4.61145 13.2493 4.80207 13.2493 5.00082C13.2493 5.19957 13.1705 5.3902 13.03 5.53082L9.03 9.53082C8.96134 9.60451 8.87854 9.66361 8.78654 9.7046C8.69454 9.7456 8.59523 9.76764 8.49452 9.76941C8.39382 9.77119 8.29379 9.75267 8.2004 9.71495C8.10701 9.67723 8.02218 9.62108 7.95096 9.54986C7.87974 9.47864 7.8236 9.39381 7.78588 9.30042C7.74816 9.20703 7.72963 9.107 7.73141 9.0063C7.73318 8.9056 7.75523 8.80628 7.79622 8.71428C7.83721 8.62229 7.89631 8.53948 7.97 8.47082L10.69 5.75082H1C0.801088 5.75082 0.610322 5.6718 0.46967 5.53115C0.329018 5.3905 0.25 5.19974 0.25 5.00082C0.25 4.80191 0.329018 4.61115 0.46967 4.47049C0.610322 4.32984 0.801088 4.25082 1 4.25082H10.69L7.97 1.53082Z"
                  fill="white"
                />
              </svg>
            </span>
          </button>
        )}
      </div>
    </Grid>
  );
};

export default CompetitionBox;
